import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/billingCode`;

export const ROUTE: RouteDefinition = `${baseRoute}/billingCode`;

export const URL = (): RouteDefinition => `${baseRoute}/billingCode`;
